module.exports = __webpack_public_path__ + "static/aide-setup-086ebca97b67fa93a8b7ec33b26056c1.mp4";